const colors = {
  purple: '#7b5ea6',
  darkPurple: '#554174',
  white: '#fff',
  offWhite: '#f9f4da',
  teal: '#15aa93',
  yellow: '#fcba28',
  pink: '#f38ba2',
  lightBlack: '#282c34',
  lightBlack60: 'rgba(40, 44, 52, 0.6)'
};

export default colors;